$(function(){


	//Accordion
	var accordion = $('.accordion');

	// initialize any accordion
	accordion.each(function(){

		var accTrigger = $(this).children('.accordion_trigger');
		var accContent = $(this).children('.accordion_content').html();

		// pull the trigger
		accTrigger.click(function(){

			var element = $(this);

			// open or close accordion
			if ( element.next('.accordion_content').hasClass('active') == true ){
				element.next('.accordion_content').removeClass('active');
				element.parent().removeClass('act');
				element.next('.accordion_content').slideUp(300);
			} else {
				element.parent().parent().find('.accordion_content.active').removeClass('active');
				element.parent().parent().find('.accordion_content').slideUp(250);
				element.parent().parent().find('.accordion.act').removeClass('act');
				element.parent().toggleClass('act');
				element.next('.accordion_content').toggleClass('active');
				element.next('.accordion_content').slideToggle(300);
			}
		});
	});

});
